import styled from '@emotion/styled';
import { StyledButton } from '~/shared/components/Button/styled';
import { useProductFilterExpandState } from '../context/useProductFilterExpandState';
import { SortingButtonProps } from '../models/M170ProductFilter';
import { ToggleableButton } from './ToggleableButton';

const StyledButtonWrapper = styled.div({
	[`${StyledButton}`]: {
		'&:focus:after, &:hover:after': {
			visibility: 'hidden',
		},
	},
});

export const SortingButton = (props: SortingButtonProps) => {
	const isExpanded = useProductFilterExpandState((state) => state.expandedOption === 'sorting');
	const {
		sorting: { options },
		onToggle,
	} = props;
	const activeSorting = options.find(({ selected }) => selected);
	return (
		<StyledButtonWrapper>
			<ToggleableButton
				label={activeSorting?.label || 'Sorting'}
				onToggle={onToggle}
				expanded={isExpanded}
			/>
		</StyledButtonWrapper>
	);
};
